import { Asset, AssetType } from '../types/config';
import { isVideo } from './is-video';

export const galleryThumbnails = (
  assets: Asset[],
  mainImageUrl?: string,
): { url: string; isVideo: boolean }[] => {
  let urls: { url: string; isVideo: boolean }[] = [];

  if (assets) {
    const gallery: Asset[] = [];

    assets.forEach((a) => {
      if (a.type === AssetType.Gallery || a.type === AssetType.MainImage) {
        gallery.push(a);
      }
    });

    if (gallery.length) {
      urls = gallery
        .slice(0, 5)
        .map((a) =>
          isVideo(a.url)
            ? { url: mainImageUrl || '', isVideo: true }
            : { url: a.url, isVideo: false },
        );
    }
  }

  return urls;
};
